export default __webpack_public_path__ + "static/media/ppt.2ed36c58.svg";